import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { MarkersInfoColors } from "../WinLineInfoMarkers";
export class RainbowMagicClassic_2Screen extends SlotGameType1_2Screen {

    protected override panelFactory: IPanelFactory = new RainbowMagicClassicPanelFactory();
    protected override helpFactory: IHelpFactory = new RainbowMagicClassicHelpFactory();

    //LED COLOR
    protected override ColorLed: string = "255,255,0\n";

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "RainbowMagicClassic");
        this.spinnableReelsParams.topBorderWidth = 0;
        this.spinnableReelsParams.bottomBorderWidth = 0;
    }

    //SEND COLOR FOR SRA
    protected override color: RewardColor =
        {
            color: "#F9F8E2",
            coloroutherStroke: "#013809",
            colorinnerStroke: "#0EE104"
        }
    protected override colorLineMarkers: MarkersInfoColors =
        {
            MarkerbackgroundColor: "linear-gradient(90deg,  rgb(64,23,8),rgb(115,62,31), rgb(115,62,31),rgb(115,62,31),rgb(64,23,8)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };
}





//Panel Colorized merged
class RainbowMagicClassicPanelFactory implements IPanelFactory {
    public CreateNewPanel(params: PanelParams): Panel {
        return new RainbowMagicClassicPanel(params);
    }
}

class RainbowMagicClassicPanel extends Panel {
    protected override ButtonBackground(): ButtonColors {
        let color: ButtonColors = {
            backgroundButtonColor: "linear-gradient(rgb(64,23,8),rgb(115,62,31), rgb(115,62,31),rgb(115,62,31),rgb(64,23,8)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            linearColor: "linear-gradient(to left , transparent, chartreuse,transparent ) 0 10 100%",
        };
        return color;
    }

}

class RainbowMagicClassicHelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new RainbowMagicClassicHelp(params);
    }
}

class RainbowMagicClassicHelp extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(2, 38, 1),rgb(3, 64, 1), rgb(85, 140, 3),rgb(3, 64, 1),rgb(2, 38, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };
        return color;
    }
}
